<mat-icon
  [svgIcon]="icon?.svgIcon"
  [ngClass]="classes"
  [attr.aria-label]="type === CignaIcon.ExternalLink ? 'external site' : null"
  [attr.aria-hidden]="type === CignaIcon.ExternalLink ? false : true"
></mat-icon>
